import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { H3 } from '@xo-union/tk-ui-typography';
import { Button } from '@xo-union/tk-component-buttons';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import AnalyticsStore from '~/glm/models/analytics-store';
import styles from './first-time-message.scss';

class OverviewFirstTimeMessage extends Component {
  goToImportPage = () => {
    const { gdsUiState, analyticsStore, history } = this.props;

    gdsUiState.setImportSpreadsheetView(true);
    analyticsStore.track('Dashboard Interaction', {
      action: 'GLM Header Interaction',
      decisionArea: 'start state cta',
      view: 'All Events',
    });
    history.push('/our-guest-list/import-spreadsheet');
  };

  openGuestModal = () => {
    const { gdsUiState, analyticsStore } = this.props;

    gdsUiState.setShowHouseholdForm(true);
    return analyticsStore.track('Dashboard Interaction', {
      action: 'add guest initiated',
      decisionArea: 'start state cta',
      view: 'All Events',
    });
  };

  render() {
    return (
      <div className={styles.messageContainer}>
        <H3>Start by Adding Your First Guests</H3>
        <p className={styles.subMessage}>
          {
            "Whether you have a spreadsheet, or you're starting from scratch, we've got the tools to help you stay organized."
          }
        </p>
        <Button className={styles.importButton} size="md" onClick={this.goToImportPage}>
          Import Guests
        </Button>
        <Button className={styles.newGuestButton} size="md" onClick={this.openGuestModal}>
          Add Guest
        </Button>
      </div>
    );
  }
}

OverviewFirstTimeMessage.propTypes = {
  gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
  analyticsStore: PropTypes.instanceOf(AnalyticsStore),
};

export default withRouter(OverviewFirstTimeMessage);
